import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { DirectContactFormTextField } from './DirectContactFormTextField'

export const DirectContactFormMessageField: FC<{
  clearErrorOnClick?: boolean
  isVisible: boolean
}> = ({ clearErrorOnClick, isVisible }) => {
  const intl = useIntl()

  if (!isVisible) {
    return null
  }

  return (
    <DirectContactFormTextField
      clearErrorOnClick={clearErrorOnClick}
      data-qa-id="contact-form-message-field"
      label={intl.formatMessage({ id: 'MessageForm.label.message' })}
      multiline
      name="message"
      required
      rows={6}
      rules={{
        required: intl.formatMessage({ id: 'form.error.input.missing' }),
      }}
    />
  )
}
